/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskSubtaskInputDto } from './TaskSubtaskInputDto';
import {
    TaskSubtaskInputDtoFromJSON,
    TaskSubtaskInputDtoFromJSONTyped,
    TaskSubtaskInputDtoToJSON,
    TaskSubtaskInputDtoToJSONTyped,
} from './TaskSubtaskInputDto';

/**
 * 
 * @export
 * @interface UpdateTaskRequestDto
 */
export interface UpdateTaskRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskRequestDto
     */
    workTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTaskRequestDto
     */
    mandatory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTaskRequestDto
     */
    requiresShutdown?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskRequestDto
     */
    estimatedDurationMinutes?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTaskRequestDto
     */
    partIds?: Array<string>;
    /**
     * When provided, replaces all subtasks (empty array clears). When omitted, existing subtasks are kept.
     * @type {Array<TaskSubtaskInputDto>}
     * @memberof UpdateTaskRequestDto
     */
    subtasks?: Array<TaskSubtaskInputDto>;
}

/**
 * Check if a given object implements the UpdateTaskRequestDto interface.
 */
export function instanceOfUpdateTaskRequestDto(value: object): value is UpdateTaskRequestDto {
    return true;
}

export function UpdateTaskRequestDtoFromJSON(json: any): UpdateTaskRequestDto {
    return UpdateTaskRequestDtoFromJSONTyped(json, false);
}

export function UpdateTaskRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'workTypeId': json['workTypeId'] == null ? undefined : json['workTypeId'],
        'mandatory': json['mandatory'] == null ? undefined : json['mandatory'],
        'requiresShutdown': json['requiresShutdown'] == null ? undefined : json['requiresShutdown'],
        'estimatedDurationMinutes': json['estimatedDurationMinutes'] == null ? undefined : json['estimatedDurationMinutes'],
        'partIds': json['partIds'] == null ? undefined : json['partIds'],
        'subtasks': json['subtasks'] == null ? undefined : ((json['subtasks'] as Array<any>).map(TaskSubtaskInputDtoFromJSON)),
    };
}

export function UpdateTaskRequestDtoToJSON(json: any): UpdateTaskRequestDto {
    return UpdateTaskRequestDtoToJSONTyped(json, false);
}

export function UpdateTaskRequestDtoToJSONTyped(value?: UpdateTaskRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'workTypeId': value['workTypeId'],
        'mandatory': value['mandatory'],
        'requiresShutdown': value['requiresShutdown'],
        'estimatedDurationMinutes': value['estimatedDurationMinutes'],
        'partIds': value['partIds'],
        'subtasks': value['subtasks'] == null ? undefined : ((value['subtasks'] as Array<any>).map(TaskSubtaskInputDtoToJSON)),
    };
}

